import styled from 'styled-components';
import { media } from '../../lib/media-queries/mixins';
export const BottomDrawer = styled.div `
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);
  border-top: 1px solid;
  border-color: var(--primary-500);
  background-color: white;
  z-index: 50;
`;
export const DrawerContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  margin: 0 auto;
  padding: 12px 16px;
  ${({ $maxWidth }) => {
    return $maxWidth ? `max-width: ${$maxWidth}px;` : null;
}}

  ${media.TabletPortraitDown `
    flex-direction: column-reverse;
  `}
`;
